const API_BASE_URL = import.meta.env.VITE_API_BASE_URL || 'http://localhost:4062';

export default API_BASE_URL;